import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../../service/auth/auth.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  public lat: number = 40.678178;
  public lng: number = -73.944158;
  public zoom: number = 12;

  constructor(private authService: AuthService) {}

  ngOnInit() {}

  subscribe() {}

  /**
   * Verifica si un usuario se ha autenticado, y tiene un token válido.
   *
   * @author Frank Edward Daza González
   * @version 2018-11-06
   */
  isAuthenticate() {
    return this.authService.isAuthenticate();
  }
}
